interface BookingSummaryProps {
  businessName: string;
  serviceName: string;
  date: string;
  startTime: string;
  endTime: string;
  durationMinutes: number;
  priceInCents: number;
}

function formatTime(time: string): string {
  const [h, m] = time.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour}:${m.toString().padStart(2, "0")} ${period}`;
}

function formatDate(dateStr: string): string {
  const [year, month, day] = dateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

function formatPrice(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hrs}h ${mins}min` : `${hrs}h`;
}

export function BookingSummary({
  businessName,
  serviceName,
  date,
  startTime,
  endTime,
  durationMinutes,
  priceInCents,
}: BookingSummaryProps) {
  return (
    <div className="rounded-lg border border-gray-200 p-4">
      <h3 className="mb-3 text-sm font-semibold text-gray-500 uppercase">Booking Summary</h3>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">Business</span>
          <span className="font-medium">{businessName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Service</span>
          <span className="font-medium">{serviceName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Date</span>
          <span className="font-medium">{formatDate(date)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Time</span>
          <span className="font-medium">{formatTime(startTime)} - {formatTime(endTime)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Duration</span>
          <span className="font-medium">{formatDuration(durationMinutes)}</span>
        </div>
        <div className="mt-2 border-t border-gray-100 pt-2 flex justify-between">
          <span className="font-semibold">Total</span>
          <span className="font-semibold">{formatPrice(priceInCents)}</span>
        </div>
      </div>
    </div>
  );
}
